import * as React from "react";

const NoMatch = (): JSX.Element => <div>Page Not found</div>;

export default NoMatch;
